import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SharedModule } from '../shared.module';
import { ExtraPageComponent } from './extra-page/extra-page.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { PrientHeaderComponent } from './prient-header/prient-header.component';
import { PrintLayoutHeaderComponent } from './Print_layout/print-layout-header/print-layout-header.component';
import { PrintLayoutFooterComponent } from './Print_layout/print-layout-footer/print-layout-footer.component';

@NgModule({
  declarations: [FileUploadComponent, BreadcrumbComponent, ExtraPageComponent, HeaderMenuComponent, PrientHeaderComponent, PrintLayoutHeaderComponent, PrintLayoutFooterComponent],
  imports: [SharedModule],
  exports: [FileUploadComponent, BreadcrumbComponent,ExtraPageComponent,HeaderMenuComponent,PrientHeaderComponent, PrintLayoutFooterComponent],
})
export class ComponentsModule {}
